import React from 'react';
import { personProfileUrl } from '../../lib/hubProfile.js';

// Wraps children in an <a> to the person's EverHub profile when a URL can be
// built from their Redmine id; otherwise renders children as-is (graceful
// fallback — no id or no <meta name="hub-base-url"> means a plain avatar/name).
// Cross-app link → new tab with rel=noopener noreferrer.
export default function PersonLink({ redmineId, className, style, children }) {
  const href = personProfileUrl(redmineId);
  if (!href) return <>{children}</>;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
    >
      {children}
    </a>
  );
}
